export enum GlobalEventTypes {
    Join = 'join',
    LowerVideoQuality = 'lowerVideoQuality',
    RaiseVideoQuality = 'raiseVideoQuality'
}

type Handler = (...args: any[]) => Promise<any>;

export class GlobalEvents {
    private events: Record<GlobalEventTypes, Handler> = {} as any;
    
    attach(type: GlobalEventTypes, callback: Handler) {
        this.events[type] = callback;
    }

    async notify(type: GlobalEventTypes, ...args: any[]) {
        if (this.events[type]) {
            await this.events[type](...args);
        }
    }

    clean() {
        this.events = {} as any;
    }
}
